import React, { useState } from 'react';

import HoverActionField from '~/components/HoverActionField';
import type { ExposureModel } from '~/components/types/exposure-types';

import InvoiceIcon from '../icons/InvoiceIcon';

import ExposureGenericInvoiceLineItemsView from './ExposureGenericInvoiceLineItemsView';

interface Props {
  exposure: ExposureModel;
}

const ExposureGenericInvoiceLineItemsContainer: React.FC<Props> = ({ exposure }) => {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  return (
    <>
      <HoverActionField icon={InvoiceIcon} onAction={() => setIsDialogOpen(true)} permanent>
        <em>Analysis</em>
      </HoverActionField>
      {isDialogOpen && (
        <ExposureGenericInvoiceLineItemsView
          exposure={exposure}
          open={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
        />
      )}
    </>
  );
};

export default ExposureGenericInvoiceLineItemsContainer;
